import { useEffect, useState } from "react";
import { MessageCircle, Save, Trash2, RefreshCw } from "lucide-react";
import { toast } from "sonner";
import api, { readError } from "../api";

export const WhatsAppSettings = () => {
  const [form, setForm] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const load = async () => {
    setError("");
    try { const { data } = await api.get("/settings/whatsapp"); setForm({ ...data, access_token: "", clear_token: false }); }
    catch (err) { setError(readError(err)); }
  };
  useEffect(() => { load(); }, []);
  const field = (key, value) => setForm(f => ({ ...f, [key]: value }));
  const save = async () => {
    setBusy(true); setError("");
    try {
      const { data } = await api.put("/settings/whatsapp", form);
      setForm({ ...data, access_token: "", clear_token: false });
      toast.success("WhatsApp ayarları kaydedildi");
    } catch (err) { setError(readError(err, "Ayarlar kaydedilemedi")); }
    finally { setBusy(false); }
  };
  return <section className="ref-block whatsapp-settings" data-testid="whatsapp-settings">
    <div className="ref-block-head"><div><MessageCircle size={18} /><b>WhatsApp Business</b></div>
      <span className="managed-chip custom" data-testid="whatsapp-config-state">{form?.enabled ? "ETKİN" : "KAPALI"}</span></div>
    {error && <p className="integration-error" role="alert" data-testid="whatsapp-settings-error">{error}</p>}
    {!form ? <button className="outline-button" data-testid="whatsapp-settings-retry" onClick={load}><RefreshCw size={14} />{error ? "Tekrar dene" : "Yükleniyor…"}</button> : <>
      <div className="settings-grid">
        <label className="toggle-inline full-field"><input type="checkbox" data-testid="whatsapp-enabled" checked={form.enabled} onChange={e => field("enabled", e.target.checked)} />WhatsApp gönderimini etkinleştir</label>
        <label>Phone Number ID<input data-testid="whatsapp-phone-id" inputMode="numeric" value={form.phone_number_id} onChange={e => field("phone_number_id", e.target.value)} /></label>
        <label>Graph API sürümü<input data-testid="whatsapp-api-version" value={form.api_version} onChange={e => field("api_version", e.target.value)} /></label>
        <label>Onaylı mesaj şablonu<input data-testid="whatsapp-template-name" placeholder="teklif_hazir" value={form.template_name} onChange={e => field("template_name", e.target.value)} /></label>
        <label>Şablon dili<input data-testid="whatsapp-template-language" placeholder="tr" value={form.template_language} onChange={e => field("template_language", e.target.value)} /></label>
        <label className="full-field">Meta erişim tokenı<input data-testid="whatsapp-access-token" type="password" autoComplete="new-password" value={form.access_token}
          placeholder={form.has_access_token && !form.clear_token ? "Kayıtlı token korunacak" : "Henüz girilmedi"} onChange={e => { field("access_token", e.target.value); field("clear_token", false); }} /></label>
      </div>
      <div className="whatsapp-template-spec" data-testid="whatsapp-template-spec"><b>UTILITY · DOCUMENT · POSITIONAL</b>
        <p>Sayın {"{{1}}"}, {"{{2}}"} numaralı teklifiniz hazırdır. Teklif bağlantısı: {"{{3}}"}</p>
        <small>PDF belge başlığı · Müşteri adı / referans / teklif linki</small></div>
      <div className="settings-actions">
        {form.has_access_token && <button className="outline-button danger" data-testid="whatsapp-remove-token" onClick={() => setForm(f => ({ ...f, clear_token: true, enabled: false, access_token: "" }))}><Trash2 size={14} />{form.clear_token ? "Kaydedince kaldırılacak" : "Tokenı kaldır"}</button>}
        <button className="primary-button" data-testid="whatsapp-save-settings" onClick={save} disabled={busy}><Save size={15} />{busy ? "Kaydediliyor…" : "WhatsApp ayarlarını kaydet"}</button>
      </div>
    </>}
  </section>;
};